import axios from 'axios';

const hostName = window.location.hostname;
let url = 'https://fmedway.com.br/wp-json/';

switch (hostName) {
  case 'ps.medway.com.br':
    url = 'https://ps.medway.com.br/wp-json/';
    break;
  default:
    break;
}

const apiPSMedway = axios.create({
  baseURL: url,
});

export default apiPSMedway;
